import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { legacyPathToStudioPath, mainSiteUrl, studioUrl } from '@/routing/studioHost';

type CrossHostRedirectProps = {
  /** 'studio' sends marketplace paths to the studio host; 'main' sends the rest back. */
  to: 'studio' | 'main';
};

/**
 * Full-page hop between the marketplace and studio origins. React Router can
 * only navigate within one origin, and each origin keeps its own session, so
 * this replaces the history entry instead of pushing one.
 */
const CrossHostRedirect = ({ to }: CrossHostRedirectProps) => {
  const { pathname, search, hash } = useLocation();
  const target =
    to === 'studio'
      ? studioUrl(`${legacyPathToStudioPath(pathname)}${search}${hash}`)
      : mainSiteUrl(`${pathname}${search}${hash}`);

  useEffect(() => {
    window.location.replace(target);
  }, [target]);

  return (
    <p role="status" aria-live="polite" className="p-6 text-sm text-muted-foreground">
      Redirecting to <a href={target}>{new URL(target).host}</a>…
    </p>
  );
};

export default CrossHostRedirect;
